import * as React from 'react';
import { SelectOption } from '../Annotation/annotation.types';
import {
  FailureModeCategoryTemplate,
  createFailureModeCategoryTemplate,
  deleteFailureModeCategoryTemplate,
  getFailureModeCategoryTemplates,
  setFormResult,
  setSelectedCode,
  setSelectedName,
  updateFailureModeCategoryTemplate
} from './failureModeCategoryTemplate.slice';
import { Button, Divider, Modal, Table } from 'antd';
import { deleteOrDeprecate } from '../../../shared/Helpers';
import SearchItem from '../../Shared/Landing/SearchForm/SearchItem';
import styles from './FailureModeCategoryTemplate.module.scss';
import { FailureModeCategoryTemplateForm } from './FailureModeCategoryTemplateForm';
import { RootState } from '../../../rootReducer';
import { connect } from 'react-redux';
import { AppDispatch } from '../../../store';

type IProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

function FailureModeCategoryTemplateTable(props: IProps) {
  const [showForm, setShowForm] = React.useState(false);
  const [selectedFailureModeCategoryTemplate, setSelectedFailureModeCategoryTemplate] = React.useState<FailureModeCategoryTemplate>();

  const onRowDelete = (id: any, method: string) => {
    Modal.confirm({
      title: 'Confirm',
      content: `Are you sure you want to ${method} Failure Mechanism template?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk: async () => {
        props.onDelete(id);
      }
    });
  };

  React.useEffect(() => {
    props.onFailureModeCategoryTemplateInit(props.size, 1);
  }, [props.onFailureModeCategoryTemplateInit, props.size]);

  const onEdit = (record: FailureModeCategoryTemplate) => {
    setSelectedFailureModeCategoryTemplate(record);
    setShowForm(true);
  };

  const onAdd = () => {
    setShowForm(true);
  };

  const onHideModal = () => {
    setSelectedFailureModeCategoryTemplate(undefined);
    setShowForm(false);
  };

  const onSubmit = (model: FailureModeCategoryTemplate) => {
    if (selectedFailureModeCategoryTemplate) {
      props.onUpdate(model);
    } else {
      props.onCreate(model);
    }
  };
  const columns = [
    {
      title: 'Code',
      key: 'code',
      dataIndex: 'code'
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description'
    },
    {
      title: 'Action',
      key: 'action',
      render: (record: any) => (
        <span>
          {!record.deprecated && (
            <>
              <Button type='link' disabled={record.deprecated} onClick={() => onEdit(record)}>
                Update
              </Button>
              <Divider type='vertical' />
              <Button type='link' onClick={() => onRowDelete(record.id, deleteOrDeprecate(record.canDelete))}>
                {deleteOrDeprecate(record.canDelete)}
              </Button>
            </>
          )}
          {record.deprecated && (
            <Button type='link' onClick={() => {}} disabled={true}>
              Deprecated
            </Button>
          )}
        </span>
      )
    }
  ];
  return (
    <div className={styles.container}>
      <h1 className='mainheader'>Failure Mode Category Templates</h1>
      {showForm ? (
        <FailureModeCategoryTemplateForm
          selectedFailureModeCategoryTemplate={selectedFailureModeCategoryTemplate}
          loading={props.formLoading}
          onHideModal={onHideModal}
          onSubmit={onSubmit}
        />
      ) : (
        ''
      )}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '1rem' }}>
            <SearchItem
              label='Code'
              value={props.selectedCode}
              values={props.codes}
              onChange={value => {
                props.onSetSelectedCode(value);
                props.onFailureModeCategoryTemplateInit(props.size, 1);
              }}
            />
          </span>
          <SearchItem
            label='Name'
            value={props.selectedName}
            values={props.names}
            onChange={value => {
              props.onSetSelectedName(value);
              props.onFailureModeCategoryTemplateInit(props.size, 1);
            }}
          />
        </div>
        <Button className={styles.addFailureModeCategory} onClick={() => onAdd()}>
          Add Failure Mode Category
        </Button>
      </div>
      <Table
        loading={props.loading}
        columns={columns}
        dataSource={props.failureModeCategoryTemplates}
        rowKey='id'
        scroll={{ y: 500 }}
        pagination={{
          current: props.currentPage,
          total: props.totalNumber,
          pageSize: props.size,
          onChange: (page: number) => {
            props.onFailureModeCategoryTemplateInit(props.size, page);
          },
          onShowSizeChange: (current: number, size: number) => {
            props.onFailureModeCategoryTemplateInit(size, 1);
          }
        }}
      />
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  failureModeCategoryTemplates: state.failureModeCategoryTemplate.failureModeCategoryTemplates,
  codes: state.failureModeCategoryTemplate.codes,
  names: state.failureModeCategoryTemplate.names,
  loading: state.failureModeCategoryTemplate.loading,
  formLoading: state.failureModeCategoryTemplate.formLoading,
  totalNumber: state.failureModeCategoryTemplate.totalNumber,
  currentPage: state.failureModeCategoryTemplate.currentPage,
  size: state.failureModeCategoryTemplate.size,
  selectedCode: state.failureModeCategoryTemplate.selectedCode,
  selectedName: state.failureModeCategoryTemplate.selectedName
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onFailureModeCategoryTemplateInit: (take: number, newPage: number) => dispatch(getFailureModeCategoryTemplates(take, newPage)),
  onSetSelectedName: (name: string | undefined) => dispatch(setSelectedName(name)),
  onSetSelectedCode: (code: string | undefined) => dispatch(setSelectedCode(code)),
  onCreate: (template: FailureModeCategoryTemplate) => dispatch(createFailureModeCategoryTemplate(template)),
  onUpdate: (template: FailureModeCategoryTemplate) => dispatch(updateFailureModeCategoryTemplate(template)),
  onDelete: (id: string) => dispatch(deleteFailureModeCategoryTemplate(id)),
  onSetFormResult: (result: boolean | undefined) => dispatch(setFormResult(result))
});

export default connect(mapStateToProps, mapDispatchToProps)(FailureModeCategoryTemplateTable);
